import React from 'react';
import { AI_TRAINER_PERSONALITIES } from '../../constants/aiTrainerPersonalities';
import FitnessProfilePrimaryBadge from '../FitnessProfile/shared/FitnessProfilePrimaryBadge';
import {
	aiTrainerCardClassName,
	aiTrainerHeadingClassName,
	aiTrainerMutedTextClassName,
	aiTrainerPrimaryButtonClassName,
	aiTrainerSecondaryButtonClassName
} from './aiTrainerStyles';

function trainerStatus(profile) {
	if (profile.ai_trainer_needs_setup) {
		return { label: 'Not set up', action: 'Configure trainer', tone: 'text-gray-500 dark:text-dark-text-secondary' };
	}

	if (!profile.ai_trainer_enabled) {
		const persona = AI_TRAINER_PERSONALITIES.find((p) => p.id === profile.ai_trainer_personality);
		return {
			label: persona ? `${persona.label} · Paused` : 'Paused',
			action: 'Open trainer',
			tone: 'text-yellow-700 dark:text-yellow-400'
		};
	}

	const persona = AI_TRAINER_PERSONALITIES.find((p) => p.id === profile.ai_trainer_personality);
	return {
		label: persona ? `${persona.label} · Active` : 'Active',
		action: 'Open trainer',
		tone: 'text-green-700 dark:text-green-400'
	};
}

export default function AiTrainerProfileList({ profiles, onSelectProfile }) {
	return (
		<div>
			<p className={`${aiTrainerMutedTextClassName} mb-4`}>
				{profiles.length === 1
					? 'Set up or open your AI trainer with a coach personality and proactive reminders.'
					: 'Choose your fitness profile to set up or open your AI trainer.'}
			</p>
			<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
				{profiles.map((profile) => {
					const status = trainerStatus(profile);

					return (
						<div
							key={profile.id}
							className={`${aiTrainerCardClassName} p-5 flex flex-col justify-between`}
						>
							<div>
								<div className="flex flex-wrap items-center gap-2">
									<h3 className={`text-lg font-semibold ${aiTrainerHeadingClassName}`}>
										{profile.name}
									</h3>
									{profile.is_primary && <FitnessProfilePrimaryBadge />}
								</div>
								<p className={`mt-2 text-sm font-medium ${status.tone}`}>{status.label}</p>
								{profile.ai_trainer_needs_setup && (
									<p className={`mt-2 ${aiTrainerMutedTextClassName}`}>
										Pick a coach personality and enable proactive reminders.
									</p>
								)}
							</div>
							<div className="mt-4">
								<button
									type="button"
									onClick={() => onSelectProfile(profile.id)}
									className={
										profile.ai_trainer_needs_setup
											? aiTrainerPrimaryButtonClassName
											: aiTrainerSecondaryButtonClassName
									}
								>
									{status.action}
								</button>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
}
